module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_fishman_sm-e8265076d184f29255afdd34eacdef2b.png";